export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyC_vC_cpFkc0ZiCdey9tEx2TMW0bNQzPjM",
    authDomain: "royal-stallion.firebaseapp.com",
    databaseURL: "https://royal-stallion.firebaseio.com",
    projectId: "royal-stallion",
    storageBucket: "royal-stallion.appspot.com",
    messagingSenderId: "296126986485",
    appId: "1:296126986485:web:ea750bc8e8576b16062dbc",
    measurementId: "G-EDH0E6EHS1"
  },
  arabic_translation:{
    //header
    "arabic":"عربى",
    "search_products":"البحث في المنتجات",
    "no_result_found":"ا يوجد نتائج ل! ", 
    "wishlist":"المفضلة",
    "my_account":"الحساب",
    "login":"الدخول",
    "my_orders":"طلباتي",
    "my_cart":"سلة التسوق",
    "my_profile":"ملفي الشخصي",
    "profile":"حسابي",
    "my_wishlist":"قائمة رغباتي",
    "logout":"الخروج",
    "home":"الرئيسية", 
    "account":"الحساب",
    "cake_builder":"الكيكات الخاصة",
    "contact_us":"اتصل بنا",
    "login_register":"دخول / تسجيل",
    "download_app":"تحميل التطبيق",
    "quick_links":"روابط سريعة",
    "reviews":"التقييمات",
    "views":"عدد المشاهدات",
    "product_code":"رقم المنتج:",
    "dimension":"الابعاد:",
    "height":"الارتفاع:",
    "width":"العرض:",
    "length":"الطول:",
    "weight":"الوزن:",
    "cm":"سم",
    "gms":"جرام",
    "availability":"توفر المنتج:",
    "Availability":"توفر المنتج",
    "in_stock":"متوفر",
    "out_of_stock":"إنتهى من المخزن",
    "price":"السعر",
    "quantity":"الكمية",
    "add_to_cart":"أضف للسلة",
    "skip":"تخطى",
    "terms_conditions":"الشروط والأحكام",
    "privacy_policy":"سياسة الخصوصية",
    "return_policy":"سياسة الاسترجاع",
    //home and footer
    "special_offers":"العروض الخاصة",
    "for_your_special_occassions":"لمناسبتك الخاصة",
    "sale":"عرض",
    "random_products":"منتجات مختارة",
    "selected_products":"منتجات مختارة",
    "subscribe_to_our_newsletter":"اشترك في بريدنا",
    "your_email_address_here":"بريدك الالكتروني",
    "subscribe":"اشترك",
    "free_shipping":"التوصيل المجاني",
    "on_order_over":" علي الطلبات اعلي من",
    "sar":"ريال",    
    "fast_easy_30_day_returns":"30 يوم استرجاع سهل وسريع",
    "avail_money_back_while_purchasing":"الاستفادة من استرداد الأموال أثناء الشراء",
    "secure_payment_checkout":"100% دفع آمن",
    "for_all_debit_credit_cards":"لجميع بطاقات مدي وفيزا",
    "customer_help_support":"يوميًا من الساعة 08:00 صباحًا إلى 12:00 صباحًا",
    "online_cusotmer_support":"دعم العملاء عبر الإنترنت",
    "open_hours":"ساعات العمل:",
    "about_us":"نبذة عنَا",
    "our_branches":"فروعنا",
    "careers":"الوظائف",
    "other_info":"معلومات اخرى",
    "mission_vision_why_us":"المهمة - الرؤية - لماذا نحن",
    "chairman_message":"كلمة الرئيس التنفيذي",
    "quality_policies":"سياسات الجودة",
    "loyality_program":"برنامج الولاء",
    "copyrights":"جميع الحقوق محفوظة  ©️ 2020 سعد الدين",
    "please_enter_email_id":"الرجاء إدخال معرف البريد الإلكتروني.",
    "see_more":"شاهد المزيد",
    "designed_and_developed_by":"تصميم وتطوير بواسطة",
    "powered_by":"مشغل بواسطة",
    //cart
    "shopping_cart":"سلة التسوق",
    "items":"منتجات",
    "your_cart_is_empty":"عربة التسوق فارغة!!!",
    "remove_item":"أزالة عنصر",
    "move_to_wishlist":"انقل الى المفضلة",
    "remove_from_wishlist":"إزالة من قائمة الرغبات",
    "continue_shopping":"استمرار بالتسوق",
    "item_total":"اجمالي العناصر",
    "vat":"ضريبة القيمة المضافة ",
    "discount":"الخصم",
    "discount_on_bill":"الخصم علي الفاتورة",
    "have_a_coupon_code":"هل تملك قسيمة ترويجة ؟",
    "coupon_code_applied":". تم قبول رمز القسيمة",
    "coupon_code_removed":"تم ازالة كوبون الخصم",
    "coupon_code":"رمز القسيمة",
    "apply":"تطبق",
    "remove":"إزالة",
    "total_amount":"المبلغ الإجمالي",
    "proceed_to_checkout":"انهاء عملية الشراء",
    "best_seller_products":"افضل المنتاجات مبيعا",
    "enter_valid_coupon":"أدخل قسيمة صالحة.",
    "product_added_to_cart":"تمت إضافة هذا المنتج إلى عربة التسوق.",
    "product_added_to_wishlist":"تمت إضافة المنتج إلى مفضلاتك.",
    "product_removed_from_wishlist":"تمت إزالة المنتج من المفضلة.",
    //checkout
    "checkout":"الدفع",
    "mobile":"التليفون المحمول",
    "shipping_method":"طريقة الشحن",
    "add_new_address":"أضف عنوان جديد",
    "delivery":"التوصيل",
    "pick_from_store":"اختار من الفروع",
    "default":"الافتراضي",
    "phone_number":"رقم هاتف",
    "select_a_store":"اختر فرعا",
    "pick_up_from_store":"استلام من فرع",
    "who_will_be_picking_up_your_order":"من سوف يقوم باستلام طلبك؟",
    "i_will_be_picking_up":"سوف اقوم باستلام الطلب",
    "someone_else":"شخص اخر",
    "text_alerts":"رسائل تنبيهات:",
    "text_when_my_order_is_ready_to_pick_up":"ارسل لي رسالة بمجرد جاهزية الطلب للاستلام",
    "order_summary":"ملخص الطلب",
    "payment_options":"خيارات الدفع",
    "online_payment":"الدفع الالكتروني",
    "VISA":"فيزا",
    "MASTER_CARD":"ماستر كارد",
    "MADA_CARD":"بطاقات مدي",
    "STC_PAY":"الدفع STC Pay",
    "STC_QITAF":"الدفع قطاف",
    "cash_on_delivery":"الدفع عند التوصيل",
    "cash_on_pickup":"الدفع عند الاستلام",
    "i_agree_to_the":"أنا أوافق على",
    "of_the_service":"من الخدمة",
    "you_pay":"المبلغ المطلوب",
    "pay_now":"ادفع الآن",
    "place_order":"تأكيد الطلب",
    "shipping_charges":"رسوم الشحن",
    "add_address":"أدخل العنوان",
    "use_my_current_location":"استخدم موقعي الحالي",
    "your_first_name":"الاسم الاول",
    "your_last_name":"الاسم الاخير",
    "this_field_is_required":"هذا الحقل مطلوب",
    "mobile_number":"الجوال",
    "enter_valid_number":"الرجاء إدخال رقم صحيح",
    "alternate_number":"رقم جوال بديل",
    "your_email":"البريد الالكتروني",
    "please_enter_valid_email":"يرجى إدخال عنوان صحيح للبريد الالكتروني",
    "company":"الشركة",
    "your_location":"موقعك.",
    "please_select_an_address":"قم باختيار عنوان",
    "CANCEL":"إلغاء",
    "update":"تحديث",
    "save":"حفظ",
    "please_add_an_address_before_proceeding_forward":"فضلا قم باضافة عنوان اولا.",
    "geocoder_failed_due_to":"فشل المكود الجغرافي بسبب: ",
    "address_added_successfully":"تم اضافة العنوان بنجاح.",
    "delivery_address_changed":"تم تغيير عنوان التوصيل.",
    "logout_successfully":"تم تسجيل الخروج بنجاح.",
    "please_accept_the_terms_conditions_to_proceed_forward":"يُرجى قبول الشروط والأحكام للمضي قدمًا",
    "please_select_pickup_store_location":"فضلا اختر الفرع لاستلام الطلب",
    "please_select_delivery_address":"فضلا اختر عنوان التوصيل",
    "select_date_and_time":"حدد التاريخ والوقت",
    "choose_delivery_time":"اختر وقت التسليم",
    "choose_pickup_time":"اختر وقت التسليم",
    "select_delivery_time":"حدد وقت التسليم",
    "please_select_delivery_time":"الرجاء تحديد وقت التسليم",

    //contact us
    "have_questions":"هل لديك اسئلة؟",
    "nature_of_enquiry":"طبيعة الاستفسار",
    "name":"اسمك",
    "full_name":"الاسم الكامل",
    "email_id":"بريدك الالكتروني",
    "message":"رسالة",
    "SUBMIT":"إرسال",
    "thank_you_for_your_response":"شكرا لردكم.",
    //login
    "returning_customer":"الدخول",
    "enter_verification_code":"أدخل رمز التحقق",
    "password":"كلمة المرور",
    "new_password":"كلمة سر جديدة",
    "password_must_be_characters_or_more":"كلمة المرور يجب ان تكون ٨ احرف او اكثر",
    "login_with_password":"تسجيل الدخول بكلمة المرور؟",
    "login_with_mobile_number":"الدخول برقم الجوال؟",
    "please_enter_OTP":"الرجاء إدخال otp",
    "enter_valid_OTP":"أدخل OTP صالح",
    "next":"التالي",
    "login_password":"الدخول باستخدام كلمة المرور",
    "login_otp":"الدخول برقم الجوال",
    "login_with_otp":"تسجيل الدخول باستخدام OTP؟",
    "didnt_receive_verification_code":"لم تستلم رمز التحقق؟",
    "RESEND":"إعادة إرسال",
    "you_exceeded_OTP_request_max_attempt_please_try_after_some_time":"لقد تجاوزت الحد الأقصى لمحاولة طلب OTP. يرجى المحاولة بعد مرور بعض الوقت",
    "loggedin_successfull_welcome":"تسجيل دخول ناجح، أهلاً بكم ",
    "invalid_OTP":"رمز التحقق غير صحيح",
    "something_went_wrong_Please_try_again_later":"هناك شئ خاطئ، يرجى المحاولة فى وقت لاحق!",
    "wait_for":" انتظر ل",
    "seconds_to_resend_OTP":" ثواني لإعادة إرسال OTP.",
    "verify":"تأكيد",
    "Enter_OTP_sent_to_your_mobile_number":"أدخل رمز التحقق المرسل إلى رقم هاتفك",
    "Not_your_number":"ليس رقمك؟",
    "Sign_in":"تسجيل الدخول",
    "Want_to_login_with_OTP":"هل تريد تسجيل الدخول باستخدام رمز التحقق؟",
    "SEND_OTP":"إرسال رمز التحقق",
    "OTP":"OTP",
    "enter_otp":"أدخل OTP",
    //product details
    "nutrition_facts":"الحقائق الغذائية",
    "description":"الوصف",
    "additional_information":"معلومات اضافية",
    "related_products":"منتجات ذات صلة",
    "name_on_cake":"الكتابة علي الكيكة",
    "see_more_reviews":"See more reviews",
    "select_candle":"Select Candle",
    "select_fillings":"Select Fillings",
    "select_weight":"Select Weight",
    "select_filling_by_choice":"Select Filling by choice",

    //product List
    "latest":"الاحدث",
    "old_products":"منتجات قديمة",
    "recommended":"الاكثر رواجا",    
    "high_low":"مرتفع > منخفض",
    "low_high":"منخفض > مرتفع",
    "show":"عرض:",
    "twenty":"٢٠",
    "thirty":"٣٠",
    "fifty":"٥٠",
    "hundred":"١٠٠",
    "sorry_no_products_found":"عفوا لا يوجد منتجات!!!",
    "categories":"التصنيفات",
    "best_sellers":"الافضل مبيعا",
    //profile address
    "address_book_entries":"ادخال العناوين",
    "address_updated_successfully":"تمت إضافة العنوان بنجاح.",
    "address_removed_successfully":"تمت إزالة العنوان بنجاح.",
    //order details
    "order_details":"تفاصيل الطلب",
    "order_no":"رقم الطلب:",
    "delivery_to":"التوصيل الي:",
    "est_delivery_date":"تاريخ التوصيل المتوقع:",
    "payment_method":"طريقة الدفع:",
    "shipment_method":"طريقة التوصيل:",
    "shop_name":"اسم الفرع:",
    "delivery_to_doorstep":"التوصيل الي الباب",
    "items_in_the_order":"الاصناف في الطلب",
    "Qty":"الكمية",
    "need_help":"هل تحتاج الي مساعدة؟",
    "sub_total":"الاجمالي الفرعي",
    "total":"الاجمالي",
    "rate_this_product":"قيم المنتج",
    "write_a_review":"اكتب تقييما",
    "review_here":"مراجعة هنا",
    "may_be_later":"ربما في وقت لاحق",
    "write_your_review_here":"اكتب رأيك هنا",
    //order list
    "sort_by":"ترتيب حسب:",
    "orders_and_returns":"الطلبات",
    "sorry_you_have_not_placed_any_orders_yet":"عفوا لم تقم بعمل اي طلب الي الان!!!",
    "order_id":"رقم الطلب:",
    "details":"التفاصيل",
    "load_more":"عرض المزيد",
    //profile
    "my_address":"عنواني",
    "first_name":"الاسم الاول",
    "last_name":"الاسم الاخير",
    "gender":"النوع",
    "male":"ذكر",
    "female":"انثي",
    "date_of_birth":"تاريخ الميلاد",
    "location":"الموقع",
    "edit":"تعديل",
    "edit_profile":"تعديل الملف الشخصي",
    "detailed_information":"معلومات مفصلة",
    "country":"الدولة",
    "select_country":"اختر الدولة",
    "account_and_email":"الحساب والبريد الالكتروني",
    "address_book":"العناوين",
    //registration
    "sign_up":"تسجيل",
    "registration":"تسجيل",
    "new_customer":"عميل جديد",
    "optional":"اختياري",
    "confirm_password":"تاكيد كلمات المرور",
    "please_enter_confirm_password":"فضلا ادخل كلمة المرور ثانية",
    "password_does_not_matched":"كلمة المرور غير متطابقة",
    "by_registering_your_details_you_agree_with_our":"بتسجيل بياناتك أنت توافق على",
    "and":"و",
    "REGISTER":"سجل",
    "please_accept_the_terms_condition_policy":"يرجى قبول الشروط والأحكام.",
    "registration_successfull_welcome":" تم التسجيل بنجاح! أهلا بك",
    //thank you
    "a_confirmation_has_been_sent_to_your_email_address":"تم إرسال تأكيد إلى بريدك الإلكتروني",
    "expected_delivery_date":"تاريخ التوصيل المتوقع:",
    "call":"اتصال",
    "or":"او",
    "email_us":"ارسل لنا عبر البريد الإلكتروني",
    "share_with_friends":"شارك مع اصدقائك",
    "your_order_placed_successfully":"تم تسجيل طلبك بنجاح!",
    "thank_you":"شكر لك!",
    "your_payment_for_order_id":"عملية الدفع للطلب",
    "was_successfull":"كان ناجحا!",
    "your_payment_was_failed":"عملية دفع فاشلة!",
    "sorry":"عفوا!",
    //wishlist
    "SEARCH":"بحث",
    "your_wishlist_is_empty":"قائمة رغباتك فارغة!!!",
    "image":"الصورة",
    "product_name":"اسم المنتج",
    "unit_price":"السعر",
    "action":"اجراء",
    "sorry_no_results_found":"عفوا لا توجد نتائج!!! ",
    //our-branches
    "clear":"ازالة",
    "sorry_no_stores_found":"عذرا ، لم يتم العثور على متاجر !!!",
    //about-us
    "who_we_are":"من نحن",
    "our_history":"تاريخنا",
    "about_heading":"من قلب المملكة كانت الانطلاقة عام  1976لتشكل حجر أساس لصناعة الحلويات العربية على أصولها في المنطقة بأكملها. توسّعت بعدها مجموعة أنواع الحلويات لتغتني بعدد كبير من الأصناف والحلويات من كل أنحاء العالم، ميزتها الجودة وعنوانها الطعم الأروع.",

    "year_1":"1976",
    "point_1976":"بداية قصة نجاح سعدالدين بتأسيس باكورة الفروع في المنطقة الشرقية بمدينة الخبر",

    "year_2":"1993",
    "point_1993":"سعدالدين يفتتح أول فروعه في المنطقة الوسطى بمدينة الرياض",

    "year_3":"1998",
    "point_1998":"بداية انتشار وتوسع سعدالدين إقليمياً عبر افتتاح أول فرع في البحرين",

    "year_4":"2003",
    "point_2003":"افتتاح مصنع سعدالدين في الدمام",

    "year_5":"2005",
    "point_2005":"افتتاح مصنع سعدالدين في جدة .افتتاح مصنع سعدالدين في الرياض .افتتاح باكورة فروع المنطقة الغربية بمدينة جدة.",

    "year_6":"2008",
    "point_2008":"إبداع سعدالدين يتجاوز الحدود مجدداً ويصل للكويت بافتتاح اول الفروع",

    "year_7":"2012",
    "point_2012":"فروع سعدالدين تضفي على المناسبات أحلى اللمسات عبر فروعها التي تجاوزت ال ١٠٠ فرعاً",

    "year_8":"2013",
    "point_2013":"سعدالدين يدخل التاريخ بتسجيل رقم عالمي سعودي في موسوعة غينيس بأكبر كيكة منحوتة على شكل خريطة المملكة",

    "year_9":"2016",
    "point_2016_1":"سعدالدين يفتتح أول فروعه في المنطقة الجنوبية بمدينة محايل عسير",
    "point_2016_2":"سعدالدين يفتتح أول فروعه في المنطقة الشمالية بمدينة عرعر",
    "point_2016_3":"شبكة فروع سعدالدين تكبر أكثر وأكثر لتبلغ ١٤٥ فرعاً",
    "point_2016_4":"سعدالدين على موعد جديد مع التاريخ بتسجيل رقم عالمي سعودي ثانٍ في موسوعة غينيس بأكبر نخلة مصنوعة من تمر",

    "point_today":"نفتخر في سعدالدين بكافة إنجازاتنا التي سطرها فريق عملنا المكون من أكثر من 2000 موظفاً منهم أكثر من 500 مواطن ومواطنة والمسيرة مستمرة بعون الله.",
    //mission-why-us
    "mission_vission_why_us":"الرؤية - المهمة - لماذا نحن", 
    "mission":"مهمتنا",
    "mission_message":"نسعى في سعدالدين لأن نكون الرواد عالمياً على صعيد شركات الصناعات الغذائية. فجوهر أعمالنا يدعم رؤيتنا عبر منح فريق عملنا حرية الابتكار في الجمع بين أفضل المكونات وتقديمها في قالب دافئ من الابتسامات.",
    "vission":"رؤيتنا",
    "vission_message":"أن نغدو مثالاً يُحتذى في قطاع الصناعات الغذائية في كافة الأسواق التي نتواجد فيها، فيما نصبح يوماً بعد يوم جزءاً من أسعد لحظات عملائنا.",
    "why_us":"لماذا نحن؟",
    "why_us_message":"عندما يرغب المستهلكون بالحصول على أجود أنواع الحلويات، فإنهم يريدون أكثر من مجرّد حلويات. إنهم يرغبون بمنتج طازج صحي، أصيل ولذيذ بالتأكيد. ومنذ تأسيسها، سعت سعدالدين إلى بناء الثقة لدى المستهلكين من خلال مجموعة واسعة من ألذ وأشهى الأصناف وأعلاها جودة لتتضمن الحلويات العربية، الحلويات الغربية، الشوكولاته، الآيس كريم والقهوة.",
    "quality_policy":"سياسة الجودة",
    "quality_policy_message":"تلتزم سعدالدين بسلامة وجودة كافة أصنافها ومنتجاتها عبر التطبيق الجاد والمستمر لأعلى مستويات الجودة والمعايير التنظيمية في‭ ‬جميع‭ ‬مراحل عملها، وبالتالي تقديم منتجات آمنة تلبي احتياجات المستهلكين، وتعزز الميزات التنافسية للشركة.‬‬",
    //terms-and-conditions
    "privacy_policy_message":"يمكنك التأكد من أمان وسرية بياناتك الشخصية التي تقدمها لموقع سعد الدين حيث نضمن سريتها التامة تجاه أي طرف آخر فيما عدا الجهات الحكومية إذا لزم الأمر.",
    "INTELLECTUAL_PROPERTY_TRADEMARK_RIGHTS":"حقوق الملكية الفكرية والعلامات التجارية",
    "INTELLECTUAL_PROPERTY_TRADEMARK_RIGHTS_MESSAGE":"جميع المحتوى المتوفر على الموقع، بما في ذلك، ولكن ليس على سبيل الحصر، النص والرسومات والشعارات والأزرار والرموز والصور ومقاطع الصوت ومصنفات البيانات والبرمجيات وتجميع كل ذلك ('المحتوى') هي ملك لـ سعدالدين ولا يجوز نسخها أو استخدامها دون موافقة خطية من الشركة.-العلامات التجارية والشعارات وعلامات الخدمة المعروضة على الموقع (بشكل جماعي، 'العلامات التجارية') هي علامات مسجلة لـ سعدالدين، والشركات التابعة له، وشركائه أو حاملي رخصته، في المملكة العربية السعودية وغيرها من البلدان، وتحميها قوانين العلامات التجارية في المملكة العربية السعودية والقوانين الدولية-لا يجوز استخدام أي جزء من الموقع يمكن استخدامه، استنساخه، تكراره، نسخه، بيعه، إعادة بيعه، الوصول إليه، أو تعديله، أو خلاف ذلك استغلاله، كليًا أو جزئيًا، لأي غرض بدون موافقة خطية مسبقة من الشركة",
    "CONTENT":"المحتوى",
    "CONTENT_MESSAGE":"يتم تعريف محتوى سعدالدين على أنه الرسومات، والصور، بما في ذلك جميع حقوق الصور والأصوات والموسيقى، والفيديو، والصوت أو النص على هذا الموقع. ويسعى سعدالدين لضمان صحة ودقة المعلومات الواردة في هذا الموقع ما لم يتعذر ذلك.-التعليقات تخضع للإشراف والموافقة قبل النشر ويحتفظ سعدالدين بحق عدم نشر أو حذف أي تعليق غير مناسب أو غير قانوني دون الرجوع لصاحبه-إذا كان لديك ملاحظة أو شكوى حول أي مشاركة أو محتوى يظهر على الموقع يُرجى مراسلتنا على البريد الإلكتروني info@saadeddin.com او الاتصال على الرقم الموحد 920017070",
    "LINKS_OF_THIRD_PARTY":"روابط الطرف الثالث",
    "LINKS_OF_THIRD_PARTY_MESSAGE_1":"عند زيارتك لموقع saadeddin.com ، يقوم الموقع بحفظ ملف تعريف ارتباط أو cookie في متصفح الإنترنت لديك في جهازك سواء كمبيوتر أو موبايل، وملف تعريف الارتباط هو ملف يحتوي بيانات تعريفية لتمييزك عن غيرك، وذلك لأجل احد الأغراض التالية:",
    "LINKS_OF_THIRD_PARTY_MESSAGE_2":"تخزين المعلومات الشخصية التي تسجلها بنفسك بالموقع، من أجل تقديمها لك عند طلبها. مثل الاسم وبريدك الإلكتروني ورابط موقعك.-للتعرف عليك عند العودة لزيارة الموقع مرة أخرى.-لمساعدتك في الحصول على الرسائل أو الخدمات الموجودة في أسرع وقت حسب تفضيلاتك السابقة.-لا يكشف موقع Saadeddin.com ملفات تعريف الارتباط الخاصة بالزائر إلى أي طرف ثالث باستثناء المذكورين هنا في سياسة الخصوصية، إلا إذا استلزم إجراء قضائي ذلك، مثل مذكرة تفتيش، مذكرة جلب، قانون شرعي، أو أمر من المحكمة.-عندما تستعمل متصفح الإنترنت لأول مرة، ستجد في معظم الحالات أن خيارات الإعداد فيه تقبل ملفات تعريف الارتباط. ويمكنك أن تغير ذلك في متصفحك وتجعله يرفض كل ملفات تعريف الارتباط أو ينبّهك حين تُرسَل ملفات تعريف ارتباط إليك وتسمح أو ترفض ذلك حسب رغبتك.",
    "USE_OF_THE_SITE":"استخدام الموقع",
    "USE_OF_THE_SITE_MESSAGE":"دخولك إلى هذه الصفحة من موقع سعد الدين تكون قد وافقت على الشروط والأحكام الخاصة بالموقع قبل القيام بأي عملية شراء.-موقع سعد الدين هو موقع إلكتروني مُصمَم بغرض عرض وتسويق وبيع منتجات وخدمات سعد الدين وخدمة عملائها والتواصل معهم.-حتى يتمكن فريق سعد الدين من معالجة طلبك وخدمتك بالشكل الصحيح فإننا ننصح بإنشاء حساب على الموقع ، مع العلم أنك لازلت تستطيع الشراء كزائر.-في حالة الدفع أونلاين، يجب أن تكون كامل البيانات التي المدخلة صحيحة لضمان وصول طلبك دون تأخير.-يضمن سعد الدين أمان وسرية بياناتك الشخصية التي تقدمها لموقع سعد الدين تجاه أي طرف آخر فيما عدا الجهات الحكومية إذا لزم الأمر.-عند الدفع على الموقع بأي وسية تم توفيرها عليه فإن جميع من قام بالشراء سواء ببطاقة ائتمان أو بطاقة دفع مسب أو أي بطاقة دفع أخرى سارية الصلاحية فإنهم يخولون سعدالدين بسحب القيمة الكلية لسعر المنتج أو المنتجات المشتراه شاملاً الضرائب الرسمية.-مع بداية تأكيدك لشراء أي من المنتجات، فأنت تسمح لسعدالدين بالتحري - بالاستعانة بطرف ثالث - عن حسابك وكفاية رصيدك وآخر حركات بطاقة الائتمان الخاصة بك، وذلك للتأكد من هويتك وضمان سلامة عملية الدفع.-قد يستخدم سعدالدين المعلومات التي تقدمها لإجراء تحريات مناسبة لمكافحة الاحتيال، وقد تحتفظ الوكالة المعنية بسجل لهذه المعلومات.-في حال تغيير المعلومات الشخصية الخاصة بك، ننصح بتحديث بياناتك على الموقع أو بالاتصال على 920017070-يحتفظ موقع سعدالدين لنفسه بحق إجراء أية تعديلات على شروط الخدمة بحسب تقديرنا الخاص ووفقًا لما نراه مناسباً.-عند دخولك و/أو استخدامك للموقع، أنت توافق على الالتزام بشروط الاستخدام التي تغيرت وأي تغييرات يتم إجراؤها بعد أن قمت بعمل طلبية، لن تؤثر على الطلبية ما لم يفرض علينا إجراء التغيير بموجب القانون.",
    "SHOPPING_ON_SAADEDDIN_WEBSITE":"التسوق على موقع سعدالدين",
    "SHOPPING_ON_SAADEDDIN_WEBSITE_MESSAGE":"عند عمل طلبية شراء من خلال موقع سعدالدين، أنت تقوم بشراء المنتج مقابل السعر المذكور، والذي يخضع لهذه الشروط علماً ان جميع الأسعار الموجودة شاملة ضريبة القيمة المضافة.-جميع الطلبيات تخضع للموافقة وتوفّر المنتج ولا يحق لمستخدم الموقع المطالبة بأي تعويض في حال عدم إمكانية تلبية طلبه أو عدم توفر المنتج الذي اشتراه وله الحق في استعادة ما دفعه مخصوماً منه أي رسوم إدارية تخص بوابة الدفع الإلكتروني أو حسابه الإئتماني الخاص به لدى البنك المزود للبطاقة.",
    "CUSTOM_FEES_AND_TAXES":"الرسوم الجمركية والضرائب",
    "CUSTOM_FEES_AND_TAXES_MESSAGE":"في حال الطلب من خارج السعودية فإن موقع سعد الدين يخلي مسؤوليته تجاه أي رسوم جمركية وضرائب حسب النظام المتبع في البلد الذي تم الشراء إليه ويتحمل المشتري كافة التفاصيل والمسؤولية النظامية بهذا الخصوص. وفي حال عدم تطبيق النظام لأي سبب فإن الطلب يتم إعادته سعد الدين مع تحميل العميل التكاليف الناشئة عن ذلك.",
    "PAYMENT_MEANS_AND_CONDITIONS":"وسائل وشروط الدفع",
    "PAYMENT_MEANS_AND_CONDITIONS_MESSAGE":"توفر سعدالدين طرق دفع متنوعة تشمل الدفع عند الاستلام، وكذلك بواسطة بطاقات الائتمان، وبطاقات الخصم المباشر، وكذلك عن طريق حساب سداد ، وطرق أخرى مثل الدفع بالنقاط التسويقية المتوفرة كرصيد لدى العملاء سواء من برامج سعد الدين التسويقية أو البرامج الأخرى التي يشارك فيها سعد الدين.",
    "REFUND_AND_EXCHANGE_POLICY":"سياسة الارجاع والإستبدال",
    "REFUND_AND_EXCHANGE_POLICY_MESSAGE":"حسب النظام المتبع في الشركة والمهلة المحددة وشروط الحفظ والتخزين وهذا البند خاضع للتحديث باستمرار.",
    "AMENDMENT_PROCEDURES_FOR_THE_PRIVACY_POLICY":"إجراءات التعديل لسياسة الخصوصية",
    "AMENDMENT_PROCEDURES_FOR_THE_PRIVACY_POLICY_MESSAGE":"يحتفط سعد الدين بالحق في إجراء أي تعديل طفيف أو جذري لشروط سياسة الخصوصية من وقت لآخر من دون الحاجة إلى تقديم إخطار بذلك. وإذا كنت ترغب بالاستمرار في استخدام الموقع بعد إدخال التعديلات على سياسة الخصوصية هذه، فإن هذا يعني قبولك لهذه التغييرات.",
    "DISPUTES":"النزاعات",
    "DISPUTES_MESSAGE":"بهذا يوافق مستخدم البوابة على الخضوع حصريًا للسلطات القضائية بالمملكة العربية السعودية فيما يتعلق بكافة المطالبات والخلافات التي قد تنشأ عن استخدامه لهذا الموقع (www.saadeddin.com) ، علماً بأن اللغة العربية ستكون هي اللغة الرسمية المستخدمة لحل أية خلافات تنشأ عن استخدامه أو أي من محتوياته.",
    "CONTACT_US":"التواصل معنا",
    "CONTACT_US_MESSAGE":"لأي طلبات أو استسفارات تخص المنتجات أو الخدمات كالشحن والتوصيل أو الشكاوي والاقتراحات يُرجى مراسلتنا علىinfo@saadeddin.com أو يمكنك الإتصال بنا على 9200 17070 خلال ساعات العمل .",
    //chairman-message-popup
    "message_1":"قصة نجاح سعدالدين بدأت عام ١٩٧٦ بتأسيس باكورة الفروع في المنطقة الشرقية بمدينة الخبر، لتنطلق منذ ذلك الوقت سلسلة الإنجازات بحلقات هامة من النجاح على المدى الطويل، مما مهد الطريق أمامنا للدخول إلى أسواقٍ جديدة.",
    "message_2":"إن الجودة هي الأساس المتين لأعمالنا، فنحرص دوماً على ألا يؤثر الحجم المتنامي لأعمالنا على جودتنا ومهارتنا في تطوير منتجاتنا، بغرض الحفاظ علعراقة إبداعات سعدالدين وتقديم منتجات ذات مستوى عالمي.",
    "message_3":"تواجه شركة سعد الدين انجازا قويا بسبب أنشطتها سواء داخل المملكة العربية السعودية أو خارجها. وعلى الرغم من كل ذلك ، فقد أثبتت الشركة خلال السنوات الماضية أنها تمتلك المصادر الرئيسية للطاقة لجعلها تواصل نجاحها في هذه البيئة التنافسية.",
    "message_4":"سعد الدين هي شركة تصنيع وتوريد الحلويات الأسرع نموًا في السوق المحلي والخارج ، على الرغم من المنافسة الشرسة محليًا ودوليًا. هذا النمو السريع لسعد الدين على مدى السنوات الماضية جعل من الممكن لها تعزيز مكانتها محليًا وإقليميًا كشركة متطورة في مجال إنتاج المواد الغذائية والحلويات.",

    //new translations
    "reviewed_on":"تمت مراجعته في",
    "reset_password":"اعادة تعيين كلمة المرور",
    "old_password":"كلمة المرور القديمة",
    "forget_password":"هل نسيت كلمة المرور؟",
    "password_changed_successfully":"تم تغيير كلمة المرور بنجاح، للاستمرار قم بالدخول",
    "menu":"القائمة",
    "close":"اغلق",
    "additional_note":"ملاحظات",
    "ingredients":"المكونات",
    "please_select":"الرجاء التحديد ",
    "find_job":"ابحث عن وظيفة",
    "job_title":"المسمي الوظيفي",
    "company_name":"اسم الشركة",
    "city_or_region":"المدينة او المنطقة",
    "browse_jobs":"استعرض العروض الوظيفية بالتصنيف او الموقع",
    "all":"الكل",
    "recent_jobs":"الوظائف الحديثة",
    "apply_now":"قدم الآن",
    "read_more":"اقرا المزيد",
    "job_related_to_you_not_listed":"هل وظيفتك التي ترغب بها غير متاحة الآن ؟",
    "custom_job_title":"المسمي الوظيفي المخصص",
    "drag_and_drop_your_cv":"قم بسحب ووضع السيرة الذاتية",
    "or_upload_your_cv":"او ارفع سيرتك الذاتية",
    "job_description":"المسمى الوظيفي",
    "responsibilities":"المسئوليات",
    "job_requirement":"متطلبات الوظيفة",
    "overview":"نظرة عامة",
    "Location":"الموقع:",
    "Job_Title":"المسمي الوظيفي:",
    "hours":"ساعات:",
    "job_type":"نوع الوظيفة:",
    "apply_for_this_job":"قدم لهذه الوظيفة",
    "apply_your_application":"قدم طلبك",
    "applying_for_the_role_of":"التقديم لوظيفة",
    "applying_for_the_role":"التقديم لوظيفة",
    "upload_your_cv":"ارفع سيرتك الذاتية",
    "submit":"ارسال",
    "cannot_add_more_files":"لا يمكن رفع اكثر من ملف",
    "you_can_only_add_pdf_doc_or_docx_file":"فقط يمكنك رفع ملفات pdf, doc, docx",
    "Please_select_a_file_to_upload":"اختر ملف ليتم الرفع",
    "part_time":"دوام جزئى",
    "full_time":"وقت كامل",
    "error":"خطأ!",
    "check_internet_connection":"يرجى التحقق من الاتصال بالإنترنت وحاول مرة أخرى",
    "something_went_wrong":"هناك خطأ ما!",
    "apply_coupon":"تطبيق",
    "shape":"شكل",
    "Character_Price":"سعر الشخصية",
    "Candle_Price":"سعر الشمع",
    "Image_Price":"سعر الصورة",
    "Name_on_Cake":"الاسم علي الكيكة",
    "Name_Price":"سعر الاسم",
    "Selected_Decoration":"الديكور المختار",
    "Decoration_Price":"سعر الديكور",
    "Flower_Price":"سعر الزهور",
    "Ballon_Price":"سعر البالون",
    "Gift_Card_Price":"سعر الكارت",
    "Gift_Card_Note":"ملاحظة تكتب علي الكارت",
    "Unified_Number":"الرقم الموحد",
    "Please_add_your_Comment":"فضلا اضف تعليقا",
    "Wallet":"المحفظة",
    "Use_Wallet":"استخدم المحفظة",
    "Delivery_Charges":"رسوم التوصيل",
    "COUNTRY":"الدولة",
    "CITY":"المدينة",
    "DISTRICT":"الحي",
    "NATIONALITY":"الجنسية",
    "QUALIFICATION":"المؤهل",
    "DATE_OF_BIRTH":"تاريخ الميلاد",
    "SELECT_COUNTRY":"اختر الدولة",
    "SELECT_CITY":"اختر المدينة",
    "SELECT_DISTRICT":"اختر الحي",
    "SELECT_NATIONALITY":"اختر الجنسية",
    "SELECT_QUALIFICATION":"اختر المؤهل",
    "currency":"ريال",
    // "Added":"اضافته",
    "Added":"تمت اضافته في",
    "partners":"الشركاء",
    "our_partners":"شركائنا",
    "blogs":"مدونات",
    "all_blogs":"كل المدونات",
    "sorry_no_blogs_found":"عفوا، لا توجد اي مدونات !",
    "faq":"اسئلة مكررة",
    "franchise":"الامتياز التجارى",
    "Our_Gallery":"المعرض",
    "Available_areas_for_franchisee":"المساحات المتاحة للامتياز التجارى",
    "Previous":"السابق",
    "Our_Franchise_models":"نماذج الامتياز التجارى",
    "View_Details":"عرض التفاصيل",
    "Financial_Information":"البيانات المالية",
    "Cash_Investment":"الاستثمار النقدي",
    "Net_worth":"صافي القيمة",
    "Franchise_Fee":"رسوم الامتياز التجارى",
    "Total_Investment":"اجمالي الاستثمار",
    "Royalty_Fee":"رسوم الامتياز",
    "Advertisement_Fee":"رسوم الاعلان",
    "YOUR_fIRST_STEP_TO_APPLY_FOR_FRANCHISE":"خطوتك الأولى لتقديم طلب الامتياز",
    "select_location":"اختر موقعا",
    "please_enter_valid_full_name":"ادخل الاسم كاملا بطريقة صحيحة",
    "We_are_pleased_to_contact_you":"يسعدنا تواصلكم معنا",
    "Working_hours":"ساعات العمل من الساعة 8:00 صباحا حتي الساعة 12:00 منتصف الليل",
    "contact_us_by_number":"او من خلال تواصلكم علي الرقم الموحد",
    "social_contacts":"اتصل بنا من هنا",
    "customer_service":"خدمة العملاء",
    "due_to":"لأن",
    "Inventors":"المخترعون",
    "cr_number":"س.ت:",
    "enable_newletter":"الاشتراك في خدمة الرسائل الإخبارية",
    "disable_account":"تعطيل الحساب",
    "your_account_is_disabled":"Your account has been disabled.",
    "branches_country":"في أي دولة ترغب بفتح الفرع/الفروع؟*",
    "branch_city":"في أي مدينة / مدن؟ ",
    "branch_investment":"كم يبلغ رأس مال الإستثمار المرصود؟",
    "branch_project":"الوقت المتوقع لتوفير السيولة والبدء في المشروع؟    ",
    "branch_franchise":"هل سبق أن كنت مانح أو ممنوح لإمتياز تجاري؟",
    "branch_food":"هل عملت سابقاً في قطاع الأطعمة (مقهى، مطعم، محل شوكولاتة أو حلويات)؟",
    "branch_store":"هل سبق لك أن امتلكت أي محل؟",
    "branch_empl":"وضعك الوظيفي حالياً:",
    "branch_work":"في حال امتلاكك لفرع/فروع ، هل تنوي العمل فيها بشكل:",
    "branch_invest":"هل تنوي الإستثمار بشكل شخصي أم أنك تمثل شركة/مؤسسة؟",
    "Wahid_branch":"فرع 1",
    "strands":"2-4 فروع",
    "More_than_branches":"أكثر من 5 فروع",
    "months":"شهور",
    "Yes":"نعم",
    "No":"لا",
    "employee":"موظف",
    "free_work":"عمل حر",
    "I_do_not_work":"لا أعمل",
    "Full_time":"دوام كامل",
    "I_do_not_intend_to_work_in_it":"لا أنوي العمل فيها",
    "institution":"مؤسسة / شركة",
    "Personal":"شخصي",
    "city_of_reidency":"مدينة الإقامة",
    "branches_saddedin":"كم فرع امتياز تجاري لسعد الدين تريد أن تفتح؟",
    "entered_amount_grater":"المبلغ المدخل اكبر من إجمالي المبلغ",
    "Please_enter_the_amount_":"فضلا ادخل المبلغ",
    "Qitaf_Deduction":"استبدال قطاف"











  },


  english_translation:{
    //header
    "arabic":"عربى",
    "entered_amount_grater":"Entered amount greater than the total amount",
    "Please_enter_the_amount_":"Please enter the amount ",
    "Qitaf_Deduction":"Qitaf Deduction", 

    "search_products":"Search products",
    "no_result_found":"No result Found",
    "wishlist":"wishlist",
    "my_account":"My Account",
    "login":"Login",
    "my_orders":"My Orders",
    "my_cart":"My Cart",
    "my_profile":"My Profile",
    "profile":"My Profile",
    "my_wishlist":"My Wishlist",
    "logout":"Logout",
    "home":"Home",
    "account":"Account",
    "cake_builder":"Cake Builder",
    "contact_us":"Contact us",
    "login_register":"Login / Register",
    "download_app":"Download app",
    "quick_links":"Quick links",
    "reviews":"Reviews",
    "views":"Views",
    "product_code":"Product Code:",
    "dimension":"Dimension:",
    "height":"Height:",
    "width":"Width:",
    "length":"Length:",
    "weight":"Weight:",
    "cm":"Cm",
    "gms":"Gms",
    "availability":"Availability:",
    "Availability":"Availability",
    "in_stock":"In Stock",
    "out_of_stock":"Out Of Stock",
    "price":"Price",
    "quantity":"Quantity",
    "add_to_cart":"ADD TO CART",
    "skip":"Skip",
    "terms_conditions":"Terms & Conditions",
    "privacy_policy":"Privacy Policy",
    "return_policy":"Return Policy",
    //home&footer
    "special_offers":"Special Offers",
    "for_your_special_occassions":"for your special occassions",
    "sale":"Sale",
    "random_products":"random products",
    "selected_products":"selected products",
    "subscribe_to_our_newsletter":"Susbcribe to our newsletter",
    "your_email_address_here":"Your email address here",
    "subscribe":"Subscribe",
    "free_shipping":"free Shipping",
    "on_order_over":"On order above",
    "sar":"SAR",
    "fast_easy_30_day_returns":"Fast & Easy 30 Day Returns",
    "avail_money_back_while_purchasing":"Avail Money Back While Purchasing",
    "secure_payment_checkout":"100% Secure Payment Checkout",
    "for_all_debit_credit_cards":"For All Debit & Credit Cards",
    "customer_help_support":"Daily from 08:00 AM to 12:00 AM",
    "online_cusotmer_support":"Online Cusotmer Support",
    "open_hours":"open hours:",
    "about_us":"about us",
    "our_branches":"our branches",
    "careers":"careers",
    "other_info":"other info",
    "mission_vision_why_us":"mission-vision-why us",
    "chairman_message":"CHAIRMAN MESSAGE",
    "quality_policies":"quality policies",
    "loyality_program":"loyality program",
    "copyrights":"Copyright ©️ 2020 by Saadeddin. All Rights Reserved",
    "please_enter_email_id":"Please enter Email Id.",
    "see_more":"See More",
    "designed_and_developed_by":"designed and developed by",
    "powered_by":"Powered By",
    //cart
    "shopping_cart":"Shopping cart",
    "items":"Items",
    "your_cart_is_empty":"Your cart is empty!!!",
    "remove_item":"remove item",
    "move_to_wishlist":"Move to wishlist",
    "remove_from_wishlist":"Remove from wishlist",
    "continue_shopping":"Continue Shopping",
    "item_total":"item total",
    "vat":"Vat",
    "discount":"Discount",
    "discount_on_bill":"Discount on Bill",
    "have_a_coupon_code":"Have a coupon code?",
    "coupon_code_applied":"Coupon code applied.",
    "coupon_code_removed":"Coupon code removed.",
    "coupon_code":"coupon code",
    "apply":"apply",
    "remove":"Remove",
    "total_amount":"Total Amount",
    "proceed_to_checkout":"PROCEED TO CHECKOUT",
    "best_seller_products":"Best Seller Products",
    "enter_valid_coupon":"Enter Valid Coupon.",
    "product_added_to_cart":"Product added to Cart.",
    "product_added_to_wishlist":"Product added to wishlist.",
    "product_removed_from_wishlist":"Product removed from wishlist.",
    //checkout
    "checkout":"checkout",
    "mobile":"Mobile",
    "shipping_method":"Shipping method",
    "add_new_address":"Add new address",
    "delivery":"Delivery",
    "pick_from_store":"Pick from Store",
    "default":"default",
    "phone_number":"phone number",
    "select_a_store":"Select a store",
    "pick_up_from_store":"Pick up from store",
    "who_will_be_picking_up_your_order":"who will be picking up your order?",
    "i_will_be_picking_up":"i will be picking up",
    "someone_else":"someone else",
    "text_alerts":"Text Alerts:",
    "text_when_my_order_is_ready_to_pick_up":"Text when my order is ready to pick up",
    "order_summary":"Order summary",
    "payment_options":"Payment Options",
    "online_payment":"Online Payment",
    "VISA":"VISA",
    "MASTER_CARD":"MASTER CARD",
    "MADA_CARD":"MADA CARD",
    "STC_PAY":"STC PAY",
    "STC_QITAF":"STC QITAF",
    "cash_on_delivery":"Cash On Delivery",
    "cash_on_pickup":"Cash On Pick up",
    "i_agree_to_the":"I agree to the",
    "of_the_service":"of the service",
    "you_pay":"You will pay",
    "pay_now":"Pay Now",
    "place_order":"Place Order",
    "shipping_charges":"Shipping Charges",
    "add_address":"Add Address",
    "use_my_current_location":"Use My Current Location",
    "your_first_name":"Your First name",
    "your_last_name":"Your Last name",
    "this_field_is_required":"This Field is required",
    "mobile_number":"Mobile Number",
    "enter_valid_number":"Enter valid Number",
    "alternate_number":"Alternate Number",
    "your_email":"Your Email",
    "please_enter_valid_email":"Please Enter valid Email",
    "company":"Company",
    "your_location":"Your Location.",
    "please_select_an_address":"Please Select an address",
    "CANCEL":"CANCEL",
    "update":"update",
    "save":"save",
    "please_add_an_address_before_proceeding_forward":"Please add an address before proceeding forward.",
    "geocoder_failed_due_to":"Geocoder failed due to: ",
    "address_added_successfully":"Address added Successfully.",
    "delivery_address_changed":"Delivery address changed.",
    "logout_successfully":"Logout Successfully.",
    "please_accept_the_terms_conditions_to_proceed_forward":"Please accept the terms & conditions to proceed forward.",
    "please_select_pickup_store_location":"Please Select pickup store location",
    "please_select_delivery_address":"Please select delivery address.",
    "select_date_and_time":"Select Date And Time",
    "choose_delivery_time":"Choose Delivery Time",
    "choose_pickup_time":"Choose Pick up Time",
    "select_delivery_time":"Select Time",
    "please_select_delivery_time":"Please Select Delivery Time",
    //contact us
    "have_questions":"Have Questions?",
    "nature_of_enquiry":"Nature of Enquiry",
    "name":"Name",
    "full_name":"Full name",
    "email_id":"Email Id",
    "message":"message",
    "SUBMIT":"SUBMIT",
    "thank_you_for_your_response":"Thank you for your response.",
    //login
    "returning_customer":"Sign In",
    "enter_verification_code":"Enter Verification Code",
    "password":"Password",
    "new_password":"New Password",
    "password_must_be_characters_or_more":"Password must be 8 characters or more",
    "login_with_password":"Login with password?",
    "login_with_mobile_number":"Login with Mobile Number?",
    "please_enter_OTP":"Please enter OTP",
    "enter_valid_OTP":"Enter valid OTP",
    "next":"Next",
    "login_password":"Login with password",
    "login_otp":"Login with Mobile Number",
    "login_with_otp":"Login with OTP?",
    "didnt_receive_verification_code":"Didn't receive Verification Code?",
    "RESEND":"RESEND",
    "you_exceeded_OTP_request_max_attempt_please_try_after_some_time":"You exceeded OTP request max attempt. Please try after some time",
    "loggedin_successfull_welcome":"Login Successfull ! Welcome ",
    "invalid_OTP":"Invalid OTP",
    "something_went_wrong_Please_try_again_later":"Something went wrong.Please try again later!",
    "wait_for":"Wait for ",
    "seconds_to_resend_OTP":" Seconds to resend OTP.",
    "verify":"Verify",
    "Enter_OTP_sent_to_your_mobile_number":"OTP sent to your mobile number",
    "Not_your_number":"Not your number?",
    "Sign_in":"Sign In",
    "Want_to_login_with_OTP":"Want to login with OTP?",
    "SEND_OTP":"SEND OTP",
    "OTP":"OTP",
    "enter_otp":"Enter OTP",

    //product details
    "nutrition_facts":"Nutrition Facts",
    "description":"Description",
    "additional_information":"Additional information",
    "related_products":"Related Products",
    "name_on_cake":"Writing on cake",
    "see_more_reviews":"See more reviews",
    "select_candle":"Select Candle",
    "select_fillings":"Select Fillings",
    "select_weight":"Select Weight",
    "select_filling_by_choice":"Select Filling by choice",
     //product List
     "latest":"Latest",
     "old_products":"Old Products",
     "recommended":"Recommended",
     "high_low":"High > Low",
     "low_high":"Low > High",
     "show":"Show:",
     "twenty":"20",
     "thirty":"30",
     "fifty":"50",
     "hundred":"100",
     "sorry_no_products_found":"Sorry, No products found!!!",
     "categories":"Categories",
     "best_sellers":"Best sellers",
     //profile address
     "address_book_entries":"Address Book Entries",
    "address_updated_successfully":"Address updated Successfully.",
    "address_removed_successfully":"Address removed Successfully.",
    //order details
    "order_details":"Order details",
    "order_no":"Order No:",
    "delivery_to":"delivery to :",
    "est_delivery_date":"est. delivery date:",
    "payment_method":"Payment method:",
    "shipment_method":"Shipment method :",
    "shop_name":"Shop Name:",
    "delivery_to_doorstep":"Delivery to doorstep",
    "items_in_the_order":"Items in the order",
    "Qty":"Qty:",
    "need_help":"Need Help?",
    "sub_total":"Sub Total",
    "total":"total",
    "rate_this_product":"Rate the Product",
    "write_a_review":"Write a Review",
    "review_here":"Review Here",
    "may_be_later":"Maybe Later",
    "write_your_review_here":"Write your review here",
    //order list
    "sort_by":"Sort By:",
    "orders_and_returns":"Orders",
    "sorry_you_have_not_placed_any_orders_yet":"Sorry You have not placed any orders yet!!!",
    "order_id":"Order Id:",
    "details":"details",
    "load_more":"load more",
    //profile
    "my_address":"My Address",
    "first_name":"First Name",
    "last_name":"Last Name",
    "gender":"Gender",
    "male":"Male",
    "female":"Female",
    "date_of_birth":"Date of Birth",
    "location":"Location",
    "edit":"edit",
    "edit_profile":"Edit Profile",
    "detailed_information":"Detailed Information",
    "country":"Country",
    "select_country":"Select Country",
    "account_and_email":"Account and email",
    "address_book":"Address book",
    //registration
    "sign_up":"Sign up",
    "registration":"Registration",
    "new_customer":"New Customer",
    "optional":"optional",
    "confirm_password":"Confirm Password",
    "please_enter_confirm_password":"Please Enter Confirm Password",
    "password_does_not_matched":"Password does not matched",
    "by_registering_your_details_you_agree_with_our":"By registering your details you agree with our",
    "and":"and",
    "REGISTER":"REGISTER",
    "please_accept_the_terms_condition_policy":"Please accept the terms & condition policy.",
    "registration_successfull_welcome":"Registration Successfull ! Welcome ",
    //thank you
    "a_confirmation_has_been_sent_to_your_email_address":"A confirmation has been sent to your email address",
    "expected_delivery_date":"Expected Delivery Date:",
    "call":"Call",
    "or":"or",
    "email_us":"Email Us",
    "share_with_friends":"Share with friends",
    "your_order_placed_successfully":"Your Order placed successfully!",
    "thank_you":"Thank you!",
    "your_payment_for_order_id":"Your Payment for Order Id",
    "was_successfull":"was successfull!",
    "your_payment_was_failed":"Your Payment was Failed",
    "sorry":"Sorry!",
    //wishlist
    "SEARCH":"SEARCH",
    "your_wishlist_is_empty":"Your wishlist is empty!!!",
    "image":"image",
    "product_name":"product name",
    "unit_price":"unit price",
    "action":"Action",
    "sorry_no_results_found":"Sorry, No Results Found!!!",
    //our-branches
    "clear":"clear",
    "sorry_no_stores_found":"Sorry, No stores found!!!",
    //about-us
    "who_we_are":"who we are",
    "our_history":"our history",
    "about_heading":"Our launch was in 1976 from the heart of the Kingdom to put the cornerstone of Arabic sweets manufacturing at its best in the whole region. The range of the kinds of sweets expanded afterwards to enrich itself with a large number of kinds and sweets from all around the world distinguished by their high quality and known for their most delicious taste.",

    "year_1":"1976",
    "point_1976":"Saadeddin opens its first branch in the middle region in Riyadh.",

    "year_2":"1993",
    "point_1993":"The beginning of Saadeddin's spread and expansion regionally through opening the first branch in Bahrain.",

    "year_3":"1998",
    "point_1998":"The opening of Saadeddin factory in Dammam.",

    "year_4":"2003",
    "point_2003":"The opening of Saadeddin factory in Jeddah. The opening of Saadeddin factory in Riyadh. The opening of Saadeddin first branch in the western region in Jeddah.",

    "year_5":"2005",
    "point_2005":"The opening of Saadeddin factory in Jeddah. The opening of Saadeddin factory in Riyadh. The opening of Saadeddin first branch in the western region in Jeddah.",

    "year_6":"2008",
    "point_2008":"Saadeddin's creativity crosses the borders again and reaches Kuwait by opening the first branch there.",

    "year_7":"2012",
    "point_2012":"Saadeddin brings to evens the most beautiful touches through its branches which exceed 100 branches.",

    "year_8":"2013",
    "point_2013":"Saadeddin enters history by recording a Saudi world record in the Guinness Book of Records for the largest cake sculptured in the shape of the map of the Kingdom.",

    "year_9":"2016",
    "point_2016_1":"Saadeddin opens its first branch in the northern region in Mahayel Aseer.",
    "point_2016_2":"Saadeddin opens its first branch in the northern region in Arar.",
    "point_2016_3":"Saadeddin's network of branches expands more and more to include 145 branches.",
    "point_2016_4":"Saadeddin is on the track of a new promise with history to have a second Saudi world record in the Guinness Books of Records for the largest palm tree made from dates.",

    "point_today":"We are proud at Saadeddin of all our achievements made by our work team that is composed of more than 2000 staff of which more than 500 are Saudi male and female citizens. And the march onwards continues, with the God's help.",
    //mission-why-us
    "mission_vission_why_us":"Mission - Vision -Why Us",
    "mission":"MISSION",
    "mission_message":"We endeavour at Saadeddin to become the leaders across the world in the field of food-manufacturing companies because the essence of our job supports our view through giving our team work the freedom to be creative in combining the best ingredients and presenting them in a warm heart of smiles.",
    "vission":"VISION",
    "vission_message":"We want to be a role model to aspire to in the field of food manufacturing in all the markets of which we are part, while becoming one day a major part of the happiest moments in our customers' lives.",
    "why_us":"WHY US?",
    "why_us_message":"When consumers desire to get the best kinds of sweets, they actually want more than merely sweets. They want fresh, healthy products that are surely original and delicious. Saadeddin has strived since it was established to build trust in consumers through a broad group of the tastiest, most delicious, and high-quality kinds that include Arabic sweets, Western sweets, chocolate, ice-cream and coffee.",
    "quality_policy":"Quality Policy",
    "quality_policy_message":"Saadeddin is committed to safety and quality for all its kinds and products through serious, continuous adherence to quality levels and organizational standards throughout all the processes of its work. This, therefore, assures the delivery of safe products that meet the demands of consumers and reinforce the competitive distinctive features of the company.",
    //terms-and-conditions
    "privacy_policy_message":"You can ensure the security and confidentiality of your personal data offered by Saadeddin Website as it makes sure the strict confidentiality towards any other party, except the government bodies, if required.",
    "INTELLECTUAL_PROPERTY_TRADEMARK_RIGHTS":"INTELLECTUAL PROPERTY & TRADEMARK RIGHTS",
    "INTELLECTUAL_PROPERTY_TRADEMARK_RIGHTS_MESSAGE":"All the content offered on the site, including but not limited to, the text, drawings, logos, buttons, codes, images, audio clips, classifications of data and software , all gathered under the (Content”) shall be the property of Saadeddin and may not be copied or used without the prior written consent of the company.-Trademarks, logos and service brands offered on the site (collectively, “Trademarks”) are brands registered to Saadeddin and its affiliated companies, partners or holders of its license in the Kingdom of Saudi Arabia and other countries and are protected by the Trademarks Laws in the Kingdom of Saudi Arabia and the international laws.-No part of the site may be used, copied, reproduced, sold, resold, accessed, amended or otherwise exploited in whole or in part for any purpose without the prior written consent of the company.",
    "CONTENT":"CONTENT",
    "CONTENT_MESSAGE":"Saadeddin content” is defined as drawings and images, including all images, audios, music and videos and the audio or text on this site, and Saadeddin seeks to ensure the correctness and accuracy of the information contained in this site unless it is not possible.-The comments are subject to supervision and approved before the publication and Saadeddin reserves its right not to publish or remove any unsuitable or illegal comment without consulting with the commentator.-If you have any remark or complaint on any post or content shown in the site, please contact us by email on info@saadeddin.com or call us on the unified number 920017070.",
    "LINKS_OF_THIRD_PARTY":"LINKS OF THIRD PARTY",
    "LINKS_OF_THIRD_PARTY_MESSAGE_1":"When you visit saadeddin.com, the site saves a cookie file in the internet explorer in your system, whether computer or mobile and the cookie is a file containing identification data to differentiate you from the other for one of the following purposes:",
    "LINKS_OF_THIRD_PARTY_MESSAGE_2":"Storing the personal data that you register yourself on the site to be available upon your request, such as your email and your location link.-Identifying you when visiting again the site.-Helping you to obtain the available messages or services as soon as possible based on your previous preferences.-saadeddin.com does not disclose the identification files of the visitor to any third party, except those mentioned here in the Privacy Policy, unless required by a legal measure, such as search warrant, summoning warrant, legitimate law or a court order.-When you use the internet explorer for the first time, you will find in most cases that the configuration options accept the cookie files and you may change it in your browser to make it refuse all the cookie files or warn you when the cookie files are sent to you or allow or refuse this as per your desire.",
    "USE_OF_THE_SITE":"USE OF THE SITE",
    "USE_OF_THE_SITE_MESSAGE":"When accessing this page of Saadeddin website, you are deemed to have agreed to the terms and conditions of the website before making any purchase operation.-Saadeddin website is a site designed to display, market and sell the products and services of Saadeddin and serve its customers and communicate with them.-In order for Saadeddin team to process your order and serve you in the proper manner, we suggest you create an account on the site, knowing that you can still make purchase as a guest.-In case of online payment, all data entered must be accuracy to ensure that your order is not delayed.-Saadeddin ensures the security and confidentiality of your personal data offered by Saadeddin Website towards any other party, except the government bodies, if required.-When making payment on the site in any mean available, all those who made a purchase with a credit card, prepaid payment card or any other payment card shall authorize Saadeddin to withdraw the total amount of the product or products bought, including the government taxes.-When confirming the purchase of any of the products, you allow Saadeddin to investigate – through a third party – your account and the sufficiency of your balance and the last movements of your credit card to verify your identity and the safety of your payment operation.-Saadeddin may use the information you provided to make proper investigations for anti-fraud and the competent agency may keep a record for this information.-In case your personal information is changed, we suggest you update your information on the site or call on 920017070.-Saadeddin reserves its right to make any changes to the service conditions as per our own discretion and as we see fit.-Upon accessing and / or using the site, you agree to adhere to the conditions of use that were changed and any changes made after you make an order, it will not affect the order unless we are obliged to make the change under the law.",
    "SHOPPING_ON_SAADEDDIN_WEBSITE":"SHOPPING ON SAADEDDIN WEBSITE",
    "SHOPPING_ON_SAADEDDIN_WEBSITE_MESSAGE":"When making a purchase order on Saadeddin website, you are purchasing the product for the said price, which is subject to these conditions, knowing that all prices include the value added tax-All orders are subject to approval and availability of the product and the user of the site may not claim any compensation if his order cannot be fulfilled or the product bought is not available and may recover the payment made minus any administrative fees for the electronic payment portal or his credit account at the bank that issued the card.",
    "CUSTOM_FEES_AND_TAXES":"CUSTOM FEES AND TAXES",
    "CUSTOM_FEES_AND_TAXES_MESSAGE":"When making a purchase from outside Saudi Arabia, Saadeddin website shall not be responsible for any custom fees and taxes as per the adopted law in the country of purchase and the buyer shall bear all the details and legal responsibility in this regard, and in case the law is not applied for any reason, the order shall be return to Saadeddin and the customer shall bear the costs as of result thereof.",
    "PAYMENT_MEANS_AND_CONDITIONS":"PAYMENT MEANS AND CONDITIONS",
    "PAYMENT_MEANS_AND_CONDITIONS_MESSAGE":"Saadeddin offers various payment methods, including payment upon delivery and through the credit cards, direct payment cards as well as through SADAD and other methods, such as the payment by available shopping points, as a balance for the customers, whether from the Saadeddin marketing programs or the other programs in which Saadeddin participate.",
    "REFUND_AND_EXCHANGE_POLICY":"REFUND AND EXCHANGE POLICY",
    "REFUND_AND_EXCHANGE_POLICY_MESSAGE":"As per the applicable law in the company, time period, storage conditions and this clause are subject to continuous update.",
    "AMENDMENT_PROCEDURES_FOR_THE_PRIVACY_POLICY":"AMENDMENT PROCEDURES FOR THE PRIVACY POLICY",
    "AMENDMENT_PROCEDURES_FOR_THE_PRIVACY_POLICY_MESSAGE":"Saadeddin reserves its right to make any minor or major amendment to the privacy policy from time to time without the need to make a notice in this respect, and if you wish to continue using the site after entering amendments to the privacy policy, it means that you agree to these amendments.",
    "DISPUTES":"DISPUTES",
    "DISPUTES_MESSAGE":"The user of the portal hereby agrees to be subject exclusively to the judicial authorities in the Kingdom of Saudi Arabia in relation to the claims and disputes that may arise from the use of this site (www.saadeddin.com), knowing that the Arabic language is the official language used to solve any disputes arising from its use or from any of its contents.",
    "CONTACT_US":"CONTACT US",
    "CONTACT_US_MESSAGE":"For any orders or questions relating to the products or services, such as shipment and delivery or the complaints and suggestions, please email us at info@saadeddin.com or you may call us on 9200 17070 during business hours.",
    //chairman-message-popup
    "message_1":"Saadeddin's success story of started in 1976 with launching the first branch in the eastern region in Alkhobar to start from that time onwards our series of achievements in important circles of long term success, which paved the way for us to enter new markets.",
    "message_2":"Quality is the solid basis of whatever we do. We do take care, therefore, to make sure that the developing size of our work does not negatively affect our quality and skills in developing our products, in order to maintain the tradition of Saadeddin's creativities and providing world standard products.",
    "message_3":"Saadeddin company faces strong completion because of its activities whether inside the Kingdom of Saudi Arabia or outride it. Despite all that, the company has proved over the past years that it has the main sources of power to make it continue its success in this competitive environment.",
    "message_4":"Saadeddin is a sweets manufacturing and supplying company that is the fastest in growing in the local market and abroad, despite the fierce competition locally and internationally. This fast growing of Saadeddin over the past years has made it possible for it to reinforce its position locally and regionally as a developed company in the field of food and sweets production.",

    //new translations
    "reviewed_on":"Reviewed on",
    "reset_password":"Reset Password",
    "old_password":"Old Password",
    "forget_password":"Forgot Password?",
    "password_changed_successfully":"Password Changed Successfully, Please Login to Continue!",
    "menu":"Menu",
    "close":"Close",
    "additional_note":"Additional Note",
    "ingredients":"Ingredients",
    "please_select":"Please Select ",
    "find_job":"Find Job",
    "job_title":"Job title",
    "company_name":"Company Name",
    "city_or_region":"city or region",
    "browse_jobs":"Browse job Offers by category or location",
    "all":"All",
    "recent_jobs":"Recent Jobs",
    "apply_now":"Apply Now",
    "read_more":"Read More",
    "job_related_to_you_not_listed":"Job related to you not listed ?",
    "custom_job_title":"Custom job title",
    "drag_and_drop_your_cv":"Drag and drop your CV",
    "or_upload_your_cv":"or upload your CV",
    "job_description":"Job Description",
    "responsibilities":"Responsibilities",
    "job_requirement":"Job Requirement",
    "overview":"Overview",
    "Location":"Location:",
    "Job_Title":"Job Title:",
    "hours":"Hours",
    "job_type":"Job type:",
    "apply_for_this_job":"Apply for this job",
    "apply_your_application":"Apply Your Application",
    "applying_for_the_role_of":"Applying for the role of",
    "applying_for_the_role":"Applying for the role",
    "upload_your_cv":"Upload your CV",
    "submit":"Submit",
    "cannot_add_more_files":"cannot add more than 1 file",
    "you_can_only_add_pdf_doc_or_docx_file":"you can only add pdf,doc or docx file",
    "Please_select_a_file_to_upload":"Please select a file to upload",
    "part_time":"Part Time",
    "full_time":"Full Time",
    "error":"Error!",
    "check_internet_connection":"Please Check your Internet Connectivity and Try again",
    "something_went_wrong":"Something went wrong!",
    "apply_coupon":"Apply",
    "shape":"Shape",
    "Character_Price":"Character Price",
    "Candle_Price":"Candle Price",
    "Image_Price":"Image Price",
    "Name_on_Cake":"Name on Cake",
    "Name_Price":"Name Price",
    "Selected_Decoration":"Selected Decoration",
    "Decoration_Price":"Decoration Price",
    "Flower_Price":"Flower Price",
    "Ballon_Price":"Ballon Price",
    "Gift_Card_Price":"Gift Card Price",
    "Gift_Card_Note":"Gift Card Note",
    "Unified_Number":"Unified Number",
    "Please_add_your_Comment":"Please add your Comment",
    "Wallet":"Wallet",
    "Use_Wallet":"Use Wallet",
    "Delivery_Charges":"Delivery Charges",
    "COUNTRY":"COUNTRY",
    "CITY":"CITY",
    "DISTRICT":"DISTRICT",
    "NATIONALITY":"NATIONALITY",
    "QUALIFICATION":"QUALIFICATION",
    "DATE_OF_BIRTH":"DATE OF BIRTH",
    "SELECT_COUNTRY":"SELECT COUNTRY",
    "SELECT_CITY":"SELECT CITY",
    "SELECT_DISTRICT":"SELECT DISTRICT",
    "SELECT_NATIONALITY":"SELECT NATIONALITY",
    "SELECT_QUALIFICATION":"SELECT QUALIFICATION",
    "currency":"SAR", 
    "Added":"Added on",
    "partners":"Partners",
    "our_partners":"Our Partners",
    "blogs":"Blogs",
    "all_blogs":"All Blogs",
    "sorry_no_blogs_found":"Sorry, No Blogs Found!!!",
    "faq":"faq's",
    "franchise":"Franchise",
    "Our_Gallery":"Our Gallery",
    "Available_areas_for_franchisee":"Available areas for franchisee",
    "Previous":"Previous",
    "Our_Franchise_models":"Our Franchise models",
    "View_Details":"View Details",
    "Financial_Information":"Financial Information",
    "Cash_Investment":"Cash Investment",
    "Net_worth":"Net worth",
    "Franchise_Fee":"Franchise Fee",
    "Total_Investment":"Total Investment",
    "Royalty_Fee":"Royalty Fee",
    "Advertisement_Fee":"Advertisement Fee",
    "YOUR_fIRST_STEP_TO_APPLY_FOR_FRANCHISE":"YOUR FIRST STEP TO APPLY FOR FRANCHISE",
    "select_location":"Select Location",
    "please_enter_valid_full_name":"Please Enter valid full name",
    "We_are_pleased_to_contact_you":"We are pleased to contact you",
    "Working_hours":"Working hours from 8:00 am to 12:00 midnight",
    "contact_us_by_number":"Or contact us with the mobile number provided below",
    "social_contacts":"Contact us here",
    "customer_service":"Customer Service",
    "due_to":"due to",
    "Inventors":"Inventors",
    "cr_number":"CR:",
    "enable_newletter":"Enable Newsletter",
    "disable_account":"Disable Account",
    "your_account_is_disabled":"Your account has been disabled.",
    "city_of_reidency":"City Of Residency",
    "branches_saddedin":"How many Saadeddin Branches do you want to open?",
    "branches_country":"In which country would you like to open the branch(s)?*",
    "branch_city":"In which city/cities?",
    "branch_investment":"How much is the allocated investment capital?",
    "branch_project":"Expected time to provide money and start the project?",
    "branch_franchise":"Have you ever been a grantor or franchisee?",
    "branch_food":"Have you previously worked in the food sector (cafe, restaurant, chocolate or pastry shop)?",
    "branch_store":"Have you ever owned any store?",
    "branch_empl":"Your current employment status:",
    "branch_work":"If you have a branch/s, do you intend to work in it in the form of:",
    "branch_invest":"Do you intend to invest personally or do you represent a company/institution?",
    "Wahid_branch":"1 branch",
    "strands":"2-4 strands",
    "More_than_branches":"More than 5 branches",
    "months":"months",
    "Yes":"Yes",
    "employee":"Employee",
    "free_work":"Free work",
    "I_do_not_work":"I do not work",
    "Full_time":"Full-time",
    "I_do_not_intend_to_work_in_it":"I do not intend to work in it",
    "institution":"Institution/company",
    "Personal":"Personal",
    "No":"No"




















  }
};